import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { Logo } from '@/shared/ui/logo'

export const Route = createFileRoute('/legal/_layout')({
  component: LegalLayout,
})

const LEGAL_LINKS = [
  { to: '/legal/privacy', label: 'Privacy Policy' },
  { to: '/legal/cookies', label: 'Cookie Policy' },
  { to: '/legal/terms', label: 'Terms of Service' },
  { to: '/legal/dpa', label: 'Data Processing Agreement' },
  { to: '/legal/subprocessors', label: 'Sub-processors' },
] as const

function LegalLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4">
          <Link to="/">
            <Logo />
          </Link>
          <Link
            to="/"
            className="text-sm text-muted-foreground hover:text-foreground"
          >
            ← Back to home
          </Link>
        </div>
      </header>

      <div className="mx-auto max-w-4xl px-6 py-10">
        <nav className="mb-10 flex flex-wrap gap-4 border-b border-border pb-6">
          {LEGAL_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-sm text-muted-foreground hover:text-foreground [&.active]:font-medium [&.active]:text-foreground"
              activeProps={{ className: 'active' }}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <Outlet />
      </div>
    </div>
  )
}
